module.exports = __webpack_public_path__ + "img/629.d316130b.png";